import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'izy-consent-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatIconModule,
  ],
  templateUrl: './consent-dialog.component.html',
  styleUrl: './consent-dialog.component.scss',
})
export class ConsentDialogComponent {
  readonly cookiePolicyUrl = environment.cookiePolicyUrl;
  readonly termsUrl = environment.termsUrl;

  accepted = new FormControl(false, Validators.requiredTrue);

  constructor(
    public dialogRef: MatDialogRef<ConsentDialogComponent>,
    private router: Router,
  ) {}

  confirm(): void {
    if (this.accepted.value) {
      this.dialogRef.close(true);
    }
  }

  logout(): void {
    this.dialogRef.close(false);
    this.router.navigateByUrl('/auth/logout');
  }
}
